import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"


const initialState = {
    data: null,
    response: null,
    loading: false,
    error: null,
    hrHandBookList: null,
    singlehrHandBook: null,
    hrHandbookLength: null,
    showPolicy: null
}

export const GethrHandBooksList = createAsyncThunk(
    "GethrHandBooksList",
    async (body) => {
        try {
            const response = await instance.get(`/crm/handbook/fetch-handbook?page=${body.page}&search=${body.search}`)
            return response.data;
        } catch (error) {
            throw error;
        }
    }
)

export const CreatehrHandBook = createAsyncThunk(
    "CreatehrHandBook",
    async (body) => {
        const formData = new FormData();
        formData.append("h_title", body.h_title);
        formData.append("h_description", body.h_description);
        formData.append("h_handbookpdf_doc", body.handbookpdf_doc[0]);
        try {
            const response = await instance.post("/crm/handbook/add-handbook", formData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
)

export const UpdatehrHandBook = createAsyncThunk(
    "UpdatehrHandBook",
    async (body) => {
        const formData = new FormData();
        formData.append("h_title", body.h_title);
        formData.append("h_description", body.h_description);
        formData.append("h_handbookpdf_doc", body.handbookpdf_doc[0]);
        try {
            const response = await instance.post("/crm/handbook/Update-handbook", formData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
)

export const removehrHandBook = createAsyncThunk(
    "removehrHandBook",
    async (id) => {
        try {
            const response = await instance.get(`/crm/handbook/remove-handbook?id=${id}`);
            return response.data
        } catch (error) {

        }
    }
)

//update status----end
export const Updatestatus = createAsyncThunk(
    "Updatestatus",
    async (data) => {
        try {
            // debugger;
            const response = await instance.post(`/crm/hrHandBooks/update-hrHandBook-status?ex_id=${data?.ex_id}`, { "ex_action": data?.ex_action })
            return response.data
        } catch (error) {
            throw error;
        }
    }
)

//update status-------end
export const HrHandBookSlice = createSlice({
    name: "HrHandBookSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(GethrHandBooksList.pending, (state) => {
            state.loading = true;
            state.data = null;
        });
        builder.addCase(GethrHandBooksList.fulfilled, (state, action) => {
            // debugger;
            state.loading = false;
            state.hrHandBookList = action.payload;
            state.hrHandbookLength = action.payload;
        });
        builder.addCase(GethrHandBooksList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });

        builder.addCase(CreatehrHandBook.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(CreatehrHandBook.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(CreatehrHandBook.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });


        builder.addCase(UpdatehrHandBook.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(UpdatehrHandBook.fulfilled, (state, action) => {
            state.loading = false;
            state.showPolicy = action.payload;
        });
        builder.addCase(UpdatehrHandBook.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });
        builder.addCase(removehrHandBook.pending, (state) => {
            state.loading = true;
            state.data = null
        })
        builder.addCase(removehrHandBook.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(removehrHandBook.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });

    }
})

export default HrHandBookSlice.reducer;